





















import { Component } from "vue-property-decorator";
import MedPartBase from "./MedPartBase";
import { STAFF_DIV_OT, STAFF_DIV_PT, STAFF_DIV_ST } from "#/const/officestaff";

@Component
export default class StaffDiv extends MedPartBase {
  private get NomalStaffDiv() {
    if (this.officeHistory.business_div == 3) {
      const excludeStaffDivs = [STAFF_DIV_PT, STAFF_DIV_OT, STAFF_DIV_ST];
      return this.masters.nomal_staff_div.filter(
        staffDiv => !excludeStaffDivs.includes(Number(staffDiv.value))
      );
    }
    return this.masters.nomal_staff_div;
  }

  private get MentalStaffDiv() {
    // 精神の場合はAPIでPT,STを除外しているためそのまま使用する
    return this.masters.mental_staff_div;
  }
}
